import React , { useState }  from "react";
import { toast , ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Navbar from "../homepage/navbar/Navbar"; // Import Navbar component
import StepUser from "./steps(new)/stepUser";
import StepRole from "./steps(new)/stepRole";
import StepDetails from "./steps(new)/stepDetails";
import StepDocuments from "./steps(new)/stepDocuments";
import StepConfirmation from "./steps(new)/stepConfirmation";
import { Link } from 'react-router-dom'; 
import { FaInfoCircle } from "react-icons/fa"; // Import the icon
import Modal from "react-modal"; // If you're using react-modal
import { handleAPIRequest } from "../../api/api";

const Signup2 = () => {
      const [documents, setDocuments] = useState([])
      const [tag, setTag] = useState('');
      const [amount, setAmount] = useState('');
      const [planId,setPlanId] = useState('');
      const [planAmount,setPlanAmount] = useState('');
        const [termsText, setTermsText] = useState("");
         const fetchTermsAndConditions = async () => {
            try {
              const response = await handleAPIRequest("get", "get-terms-and-conditions");
              if (response) {
                setTermsText(response.termsText || "No Terms & Conditions available.");
                setIsModalOpen(true); // Show modal when terms are fetched
              }
            } catch (error) {
              toast.error("Failed to fetch Terms & Conditions.");
            }
          };
        const [isModalOpen, setIsModalOpen] = useState(false);
      const updateTag = (newTag) => {
        setTag(newTag); // Update the tag state in the parent
      };
      const updateAmount = (newAmount) => {
        setAmount(newAmount); // Update the tag state in the parent
      };
      const [userInfo, setUserInfo] = useState({
        name: '',
        phone: '',
        email: '',
        password: '',
        address: '',
        country: '',
        role: '',
        companyDetails: { companyName: '', regNo: '', address: '', website: '' },
        supplierDetails: { supplierName: '', regNo: '', address: '' },
        donorDetails: { donorName: '', address: '', website: '' },
        documents: []
      });
    
      const updateDocuments = (newDocuments) => {
        setDocuments(newDocuments);
      };
    
      const updateUserInfo = (field) => (e) => {
        const value = e.target.value;
        const keys = field.split('.'); // Split field path into an array
    
        setUserInfo((prevState) => {
          const updatedInfo = { ...prevState };
          let temp = updatedInfo;
    
          // Traverse the keys and assign the value to the correct nested field
          keys.forEach((key, index) => {
            if (index === keys.length - 1) {
              temp[key] = value; // Set value at the last key
            } else {
              if (!temp[key]) temp[key] = {}; // Create the nested object if it doesn't exist
              temp = temp[key]; // Move deeper into the object
            }
          });
          return updatedInfo; // Return the updated state
        });
      };
    
      const updateRole = (role) => {
        setUserInfo((prevState) => ({
          ...prevState,
          role: role,
          companyDetails: { companyName: '', regNo: '', address: '', website: '' }, // Reset company details
          supplierDetails: { supplierName: '', supplierCategory:'', regNo: '', address: '',country:'' }, // Reset supplier details
          donorDetails: { donorName: '', address: '', website: '' } // Reset donor details
        }));
      };
  return (
    <div className="min-h-screen flex flex-col bg-cover bg-center bg-gray-300">
      <Navbar /> {/* Add Navbar here */}

      <div className="flex flex-col items-center px-4 py-10">
        {/* Signup Heading */}
        <h1 className="text-4xl font-bold text-center mb-8">Signup to NGOs Tenders Portal</h1>
        <div className="fixed bottom-4 right-4 z-50">
          <FaInfoCircle
            className="text-blue-600 text-4xl cursor-pointer hover:text-blue-800"
            onClick={() => fetchTermsAndConditions()}
            title="View Terms & Conditions"
          />
        </div>
        {/* User Information Card */}
        <div className="w-full bg-white shadow-md rounded-lg p-6 mb-6">
          {/* <h2 className="text-2xl font-semibold mb-4">User Information</h2> */}
          <StepUser userInfo={userInfo} updateUserInfo={updateUserInfo} />
        </div>

        {/* Select Your Role Card */}
        <div className="w-full bg-white shadow-md rounded-lg p-6 mb-6">
          {/* <h2 className="text-2xl font-semibold mb-4">Select Your Role</h2> */}
            <StepRole updateRole={updateRole} setPlanId={setPlanId} setPlanAmount={setPlanAmount} />
        </div>

        {/* Role Details Card */}
        <div className="w-full bg-white shadow-md rounded-lg p-6 mb-6">
          {/* <h2 className="text-2xl font-semibold mb-4">Role Details</h2> */}
         <StepDetails userInfo={userInfo} updateUserInfo={updateUserInfo} />
        </div>

        {/* Payment Documents Card */}
        <div className="w-full bg-white shadow-md rounded-lg p-6 mb-6">
          <h2 className="text-2xl font-semibold mb-4">Payment Documents</h2>
            <StepDocuments   updateDocuments={updateDocuments}
          existingDocument={documents[0]} // Pass existing document
          updateTag={updateTag} // Pass the updateTag function
          updateAmount={updateAmount} 
          planAmount={planAmount}
          />
        </div>

        <div className="w-full bg-white shadow-md rounded-lg p-6 mb-6 ">
          {/* <h2 className="text-2xl font-semibold mb-4"></h2> */}
           <StepConfirmation userInfo={userInfo} documents={documents} tag={tag} amount={amount} planId={planId} />
        </div>
        {/* Signup Button
        <button 
        onClick={() => setConfirm(true)}
        className="w-full md:w-1/3 py-4 px-6 bg-black text-white font-bold rounded-lg hover:bg-gray-800 mb-4">
          Signup
        </button> */}

        {/* Already Have an Account Label */}
      <Link to="/login" className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600">
                 Already Signed Up? Login
               </Link>
      </div>
 {/* Terms & Conditions Modal */}
 <Modal
      isOpen={isModalOpen}
      onRequestClose={() => setIsModalOpen(false)}
      className="fixed inset-0 flex items-center justify-center z-50"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50"
    >
      <div className="bg-white p-6 rounded-lg shadow-xl w-11/12 sm:w-3/4 md:w-2/3 lg:w-3/5 max-w-4xl h-auto max-h-[80vh] flex flex-col">
        {/* Title */}
        <h2 className="text-xl sm:text-2xl font-bold mb-4 text-center">
          Terms & Conditions
        </h2>

        {/* Scrollable Content */}
        <div className="flex-grow overflow-y-auto text-gray-700 p-2 border border-gray-300 rounded-md max-h-[50vh] text-sm sm:text-base">
          <div dangerouslySetInnerHTML={{ __html: termsText }} />
        </div>

        {/* Submit Button */}
        <div className="flex justify-end mt-4">
         
          <button
            onClick={() => {
              setIsModalOpen(false);
            }}
           
            className={`ml-4 px-4 py-2 rounded-lg text-white bg-gray-400`}
          >
            Close
          </button>
        </div>
      </div>
    </Modal>

      <ToastContainer />
    </div>
  );
};

export default Signup2;
